import { ApiParameter, get, HasPagingParameters, patch, post, request } from "@insite/client-framework/Services/ApiService";
import { AttributeTypeFacetModel, BaseModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";

const apiUri = "api/v1/annualReturns";

export interface UpdateApprovalStatusParameter extends ApiParameter {
  cartId: string;
  approvalStatus?: string;
  approvalMessage?: string;
}

export interface AnnualReturnsGetApprovalParameter extends ApiParameter {
  startDate?: string;
  endDate?: string;
  status?: string;
  customerNumber?: string;
  customerName?: string;
  currentPage?: number;
  pageSize?: number;
}

export interface AnnualReturnsSendInquiryParameter extends ApiParameter {
  message?: string;
  recipients?: string[];
  userName?: string;
  ccRecipient?: string;
}

export type AnnualReturnsOrderApprovalModel = {
  customerNumber: string;
  customerName: string;
  orderDate: string;
  customerOrderId: string;
  orderTotal: number;
  initialAllowance: number;
  initialAllowanceDisplay: string;
  availableAllowance: number;
  availableAllowanceDisplay: string;
  approvalMessage: string;
}

export type AnnualReturnsGetApprovalResult = {
  count: number;
  errorMessage: string;
  result: AnnualReturnsOrderApprovalModel[];
}

export type AnnualReturnsOrderLineModel = {
  orderLineId: string;
  erpNumber: string;
  shortDescription: string;
  qtyOrdered: number;
}

export type AnnualReturnsGetApprovalDetailsResult = {
  id: string;
  createdBy: string;
  grandTotal: number;
  orderLines: AnnualReturnsOrderLineModel[];
}

export async function updateAnnualReturnsApprovalStatus(parameter: UpdateApprovalStatusParameter) {
  try {
    const result = await patch<any>(`${apiUri}/updateApprovalStatus`, parameter);
    return {
      successful: true,
    };
  } catch (error) {
    return {
      successful: false,
      errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
      statusCode: error?.status,
    };
  }
}

export async function removeAnnualReturnsApprovalStatus(cartId: string) {
  try {
    const result = await patch<any>(`${apiUri}/removeApprovalStatus?cartId=${cartId}`, {});
    return {
      successful: true,
    };
  } catch (error) {
    return {
      successful: false,
      errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
      statusCode: error?.status,
    };
  }
}

export async function getOrderApprovalDetails(cartId: string) {
  try {
    const result = await get<AnnualReturnsGetApprovalDetailsResult>(`${apiUri}/getOrderApprovalDetails?cartId=${cartId}`, {});
    return {
      result,
      successful: true,
      errorMessage: "",
      statusCode: 200,
    };
  } catch (error) {
    return {
      result: undefined,
      successful: false,
      errorMessage: error?.errorJson?.message || error?.errorMessage || "error",
      statusCode: error?.status,
    };
  }
}

export async function getAnnualReturnsBalance(customerId: string, allowance: string) {
  const response = await get<any>(`${apiUri}/balance`, {
    customerId,
    allowance,
  } as ApiParameter);
  return response;
}

export async function getOrderApprovalList(parameter: AnnualReturnsGetApprovalParameter) {
  try {
    const result = await post<AnnualReturnsGetApprovalParameter, AnnualReturnsGetApprovalResult>(`${apiUri}/getOrderApproval`, parameter);
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function sendInquiry(parameter: AnnualReturnsSendInquiryParameter) {
  try {
    const result = await post<AnnualReturnsSendInquiryParameter, boolean>(`${apiUri}/sendInquiry`, parameter);
    return result;
  } catch (error) {
    console.log(error);
    return false;
  }
}

export async function getContacts(customerId: string) {
  const response = await get<string[]>(`${apiUri}/getContacts`, {
    customerId,
  } as ApiParameter);

  return response;
}